import { gql, useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import SessionActions from '../../account/SessionActions';
import USER_SETTINGS_FIELDS_FRAGMENT from '../../graphql/fragments/UserSettingsFields';
import type {
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables,
} from '../../graphql/generated/graphqlTypes';

const USER_SETTINGS_MUTATION = gql`
  mutation updateUserSettings(
    $allowAccountAccess: Boolean
    $notifications: UserSettingsNotificationsInput
    $uiTheme: UiThemeSetting
  ) {
    settings: updateUserSettings(
      allowAccountAccess: $allowAccountAccess
      notifications: $notifications
      uiTheme: $uiTheme
    ) {
      ...UserSettingsFields
    }
  }

  ${USER_SETTINGS_FIELDS_FRAGMENT}
`;

export default function useUpdateUserSettings() {
  const dispatch = useDispatch();
  const [mutate] = useMutation<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >(USER_SETTINGS_MUTATION);

  return (params: UpdateUserSettingsMutationVariables) =>
    mutate({ variables: params }).then(({ data } = {}) => {
      if (data?.settings) {
        dispatch(SessionActions.setUserSetting(data.settings));
      }
    });
}
